/**
 *  layouts/Dashboard.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

// system
import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

// components
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import Footer from "../../components/Footer/Footer";

// notifications
import NotificationSystem from "react-notification-system";

// routes
import adminRoutes from "../../routes/admin.jsx";

// redux
import { connect } from 'react-redux';

// style
import { style } from "../../variables/Variables.jsx";

// global
var utils = require("../../utils");

class Dashboard extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      _notificationSystem: null
    };
  }

  componentDidMount() {
    utils.isLogged(); // Verifica credenciais do usuario
  }

  componentDidUpdate(e) {
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
    if (e.history.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }
  }

  render() {
    const { account } = this.props;

    return (
      <div className="wrapper">
        <NotificationSystem ref="notificationSystem" style={style} />
        <Sidebar {...this.props} role={account.role}/>

        <div id="main-panel" className="main-panel" ref="mainPanel">
          <Header {...this.props} />
          <Switch>
            {adminRoutes.map((prop, key) => {
              if (prop.redirect)
                return <Redirect from={prop.path} to={prop.to} key={key} />;
              return (
                <Route path={prop.path} exact component={prop.component} key={key} />
              );
            })}
          </Switch>
          {/* <Footer /> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = store => ({
  account: store.account.account
});

export default connect(mapStateToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Dashboard.jsx